import { render, staticRenderFns } from "./Robot_ai_vip_detail.vue?vue&type=template&id=f645a8f4&scoped=true"
import script from "./Robot_ai_vip_detail.vue?vue&type=script&lang=js"
export * from "./Robot_ai_vip_detail.vue?vue&type=script&lang=js"
import style0 from "./Robot_ai_vip_detail.vue?vue&type=style&index=0&id=f645a8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f645a8f4",
  null
  
)

export default component.exports